var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTelevision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 12C9 10.8954 9.89543 10 11 10H21C22.1046 10 23 10.8954 23 12V17C23 18.1046 22.1046 19 21 19H11C9.89543 19 9 18.1046 9 17V12ZM11 11H21C21.5523 11 22 11.4477 22 12V17C22 17.5523 21.5523 18 21 18H11C10.4477 18 10 17.5523 10 17V12C10 11.4477 10.4477 11 11 11Z",
    fill: "#00112B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 20C12.4477 20 12 20.4477 12 21C12 21.5523 12.4477 22 13 22H19C19.5523 22 20 21.5523 20 21C20 20.4477 19.5523 20 19 20H13Z",
    fill: "#00112B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelevision);
export default __webpack_public_path__ + "static/media/television.e515d7acd143febc8ada7d79b394bf33.svg";
export { ForwardRef as ReactComponent };